export const aciModo = {
    iconName: 'modo',
    iconData: [
        24,
        24,
        `M15.605.688a1.582 1.582 0 00-1.762.58L8.349 8.9 2.856 1.268A1.573 1.573 0 001.217.654a1.568 1.568 0 00-.923 2.441l6.771 9.407a1.574 1.574 0 001.283.66 1.58 1.58 0 001.284-.66l3.915-5.439v7.771c0 .416.166.815.462 1.11a1.579 1.579 0 002.227 0c.296-.295.462-.694.462-1.11V2.181A1.564 1.564 0 0015.605.688zM1.62 8.508a1.564 1.564 0 00-1.566 1.568v4.81a1.57 1.57 0 001.567 1.568 1.567 1.567 0 001.567-1.569v-4.809a1.569 1.569 0 00-1.567-1.568z`,
    ],
};
